export default "__VITE_ASSET__By3MKu67__"